import axios from "axios";
import { BASE_URL } from "../config";
import { SET_ABOUT_DATA, SET_FAQ_DATA, SET_HOME_DATA, SET_LOADING, SET_PAGE, SET_PRIVACY_DATA,SET_COURSE_DATA, SET_SETTING_DATA, SET_TERMS_DATA } from "./Action";

// const setRazorPay = (data) => ({
//   type: SET_LOADING,
//   payload: data,
// });

const setLoading = (data) => ({
    type: SET_LOADING,
    payload: data,
  });
export  const setCurrentPage = (data) => ({
    type: SET_PAGE,
    payload: data,
  });
  const setHomepageData = (data) => ({
    type: SET_HOME_DATA,
    payload: data,
  });
  const setAboutData = (data) => ({
    type: SET_ABOUT_DATA,
    payload: data,
  });
  const setPrivacyData = (data) => ({
    type: SET_PRIVACY_DATA,
    payload: data,
  });
  const setTermsData = (data) => ({
    type: SET_TERMS_DATA,
    payload: data,
  });
  const setFaqData = (data) => ({
    type: SET_FAQ_DATA,
    payload: data,
  });
  const setCourseData = (data) => ({
    type: SET_COURSE_DATA,
    payload: data,
  });
  const setSettingData = (data) => ({
    type: SET_SETTING_DATA,
    payload: data,
  });


  export const getHomaData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/home`,path)
    dispatch(setHomepageData(data.data));
    dispatch(setLoading(false));
    dispatch(setCurrentPage("home"));
  }
  export const getAboutData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/cms/6`,path)
    dispatch(setAboutData(data.data));
    dispatch(setLoading(false));
    dispatch(setCurrentPage("about"));
  }
  export const getPrivacyData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/cms/4`,path)
    dispatch(setPrivacyData(data.data));
    dispatch(setLoading(false));
    dispatch(setCurrentPage("privacy"));
  }
  export const getTermsData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/cms/2`,path)
    dispatch(setTermsData(data.data));
    dispatch(setLoading(false));
    dispatch(setCurrentPage("terms"));
  }
  export const getFaqData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/getfaq`,path)
    dispatch(setFaqData(data.data));
    dispatch(setLoading(false));
    dispatch(setCurrentPage("faq"));
  }
  export const getCourseData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/course`,path)
    dispatch(setCourseData(data.data));
    dispatch(setLoading(false));
    dispatch(setCurrentPage("course"));
  }
  export const getSettingData=(path)=>async(dispatch)=>{
    let data = await axios.get(`${BASE_URL}/api/settings`,path)
    dispatch(setSettingData(data.data));
    dispatch(setLoading(false));
  }

